import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { BarChart3, Shield, Cog, Megaphone, TrendingUp, ShoppingCart, Headphones } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const pillars = [
  { icon: BarChart3, title: "Performance-Messung", desc: "Interaktionen, Sitzungen und Kontakte in Echtzeit" },
  { icon: Shield, title: "Qualitätsmonitoring", desc: "Automatisierungsquote, Fallback-Rate und Bewertungen" },
  { icon: Cog, title: "Prozessoptimierung", desc: "Übergaben, Eskalationen und Effizienzpotenziale" },
];

const agents = [
  { icon: Megaphone, name: "Marketing Agent", iconColor: "text-chathero-mint", iconBg: "bg-chathero-mint/20", iconBorder: "border-chathero-mint/50" },
  { icon: TrendingUp, name: "Sales Agent", iconColor: "text-chathero-orange", iconBg: "bg-chathero-orange/20", iconBorder: "border-chathero-orange/50" },
  { icon: ShoppingCart, name: "Commerce Agent", iconColor: "text-chathero-orange", iconBg: "bg-chathero-orange/20", iconBorder: "border-chathero-orange/50" },
  { icon: Headphones, name: "Kundenservice Agent", iconColor: "text-chathero-mint", iconBg: "bg-chathero-mint/20", iconBorder: "border-chathero-mint/50" },
];

const AnalyticsSteuerzentraleSection = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className={cn(
        "py-16 md:py-24 transition-all duration-700 ease-out",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      )}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">Überblick</Badge>
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
            Die Steuerzentrale Ihrer KI
          </h2>
          <p className="text-lg text-muted-foreground">
            Ein zentrales, plattformübergreifendes Dashboard – Analytics ist standardmäßig integriert, alle Insights stehen in Echtzeit zur Verfügung.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {pillars.map((pillar, i) => (
            <div key={i} className="bg-card border border-border rounded-2xl p-6 shadow-sm text-center">
              <div className="w-12 h-12 rounded-xl bg-chathero-mint/10 flex items-center justify-center mx-auto mb-4">
                <pillar.icon className="w-6 h-6 text-chathero-mint" />
              </div>
              <h3 className="font-bold text-foreground mb-2">{pillar.title}</h3>
              <p className="text-sm text-muted-foreground">{pillar.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AnalyticsSteuerzentraleSection;
